import { render, staticRenderFns } from "./support.component.html?vue&type=template&id=2e320a34&scoped=true&"
import script from "./support.component.ts?vue&type=script&lang=ts&"
export * from "./support.component.ts?vue&type=script&lang=ts&"
import style0 from "./support.component.scss?vue&type=style&index=0&id=2e320a34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e320a34",
  null
  
)

export default component.exports